import { createContext, useContext } from 'react'
import { type FlowManager } from '~/components/flows/FlowProvider'

export const FlowContext = createContext<FlowManager | null>(null)

export function useFlowManager() {
  const context = useContext(FlowContext)

  if (!context) {
    // eslint-disable-next-line i18next/no-literal-string
    throw new Error('useFlowManager must be used within a FlowProvider')
  }

  return context
}
